import { ActivityBookingDetails } from "./ActivityBookingDetails";
import { summarizeParticipantsExport } from "./participants-export";

export type ExportSummary = ReturnType<typeof summarizeParticipantsExport>;

export function createParticipantsExportSession() {
    const worker = new Worker(new URL("./participants-export.worker.ts", import.meta.url));
    let rejectPending: ((reason: Error) => void) | undefined;
    let disposed = false;
    const request = <T,>(message: unknown): Promise<T> => new Promise((resolve, reject) => {
        if (disposed) return reject(new Error("Estrazione chiusa"));
        if (rejectPending) return reject(new Error("Estrazione gia in corso"));
        rejectPending = reject;
        worker.onmessage = ({ data }) => {
            rejectPending = undefined;
            if (data.error) reject(new Error(data.error));
            else resolve(data.result);
        };
        worker.onerror = () => { rejectPending = undefined; reject(new Error("Impossibile avviare l’estrazione")); };
        worker.onmessageerror = () => { rejectPending = undefined; reject(new Error("Risposta estrazione non valida")); };
        try { worker.postMessage(message); }
        catch (error) { rejectPending = undefined; reject(error); }
    });
    return {
        prepare: (bookings: ActivityBookingDetails[]) => request<ExportSummary>({ action: "prepare", bookings }),
        download: (format: "CSV" | "PDF") => request<Blob>({ action: "download", format }),
        dispose: () => {
            disposed = true;
            worker.terminate();
            rejectPending?.(new DOMException("Estrazione annullata", "AbortError"));
            rejectPending = undefined;
        },
    };
}
